import $ from "jquery"
// these imports are used for the dropdown functions
import Popper from "popper.js"
import Bootstrap from "bootstrap"

export const controlsHelper = {
  methods: {
    handleDropdownEvents: function (baseName, shouldShowMenu) {
      var className = "#" + baseName + "MenuLink"
      var menuName = "." + baseName + "Menu"
      if (shouldShowMenu) {
        $(className).dropdown("toggle")
      } else {
        $(className).next(menuName).removeClass("show")
        $(className).closest("div.dropdown").removeClass("show")
      }
    },
    clickEvent: function (linkUrl) {
      top.location = linkUrl
    },
    getFileTypeIcon: function(fileType){
      switch(fileType){
        case "doc":
        case "docx":
          return ["far", "file-word"]
        case "jpg":
          return ["far", "file-image"]
        case "pdf":
          return ["far", "file-pdf"]
        case "ppt":
        case "pptx":  
          return ["far", "file-powerpoint"]
        case "xls":
        case "xlsx":
          return ["far", "file-excel"]     
        default:
          return ["far", "file"]
      }
    }
  }
}
